import {Injectable, OnDestroy} from "@angular/core";
import { BehaviorSubject, debounceTime, tap } from "rxjs";
import { BezwaarEntity } from './api.bokkz.bezwaar';

@Injectable({providedIn: 'root'})
export class BokkzBezwaarDataService implements OnDestroy {

  public bezwaarEntityList = new BehaviorSubject<BezwaarEntity[]>(this.getFromSessionStorage<BezwaarEntity[]>('BezwaarEntityList') || {} as BezwaarEntity[]);
  public bezwaarEntity = new BehaviorSubject<BezwaarEntity>(this.getFromSessionStorage<BezwaarEntity>('BezwaarEntity') || {} as BezwaarEntity);

  constructor() {
    this.applyDebounceTime();
  }

  private applyDebounceTime() {
    this.bezwaarEntity.pipe(
      debounceTime(500),
      tap((value) => this.saveToSessionStorage('BezwaarEntity', value))).subscribe();
    this.bezwaarEntityList.pipe(
      debounceTime(500),
      tap((value) => this.saveToSessionStorage('BezwaarEntityList', value))).subscribe();
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private saveToSessionStorage(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  updateList(all: BezwaarEntity[]) {
    this.bezwaarEntityList.next(all)
  }

  updateItem(bezwaarEntity: BezwaarEntity) {
    this.bezwaarEntity.next(bezwaarEntity)
  }

  ngOnDestroy(): void {
    if (this.bezwaarEntityList) {
      this.bezwaarEntityList?.unsubscribe()
    }
    if (this.bezwaarEntity) {
      this.bezwaarEntity?.unsubscribe()
    }
  }
}
